import { PromocodeBaseModel } from './promocode-base.model';

export class PromocodePrivateEmailModel extends PromocodeBaseModel {
  emails: string[] = [];
}
